import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { showSpinner } from '../../../actions'
import MyResults from './MyResults'

const mapStateToProps = (state) => {
  return {
    userId: state.user.data._id
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ showSpinner }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyResults)
